import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { push } from 'react-router-redux'
import { openMenu, closeMenu, toggleMenu } from '../../ducks/ui'

function mapStateToProps (state, ownProps) {
  return {
    ...ownProps,
    menuOpen: state.ui.menuOpen,
    path: state.router.location.pathname
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    navigate: push,
    openMenu,
    closeMenu,
    toggleMenu
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/side_menu/index.js